<app-tabs
  [defaultTab]="defaultTab()"
  (onChangeTab)="onTabChange($event)"
>
  <app-sales-sheet-tab />
  <app-sales-products-tab />
  <app-sales-bricks-tab />
  <app-sales-customers-tab />
</app-tabs>
